import { EnumObject, EnumValue } from '@ha/utilities/Enum';

import { parseRouteParamToEnum } from './parseRouteParamToEnum';

export function parseRouteParamToEnumArray<T extends EnumObject>(
  value: string | null | undefined,
  enumType: T,
): Array<EnumValue<T>> {
  const result: Array<EnumValue<T>> = [];

  if (typeof value === 'string') {
    for (const item of value.split(',')) {
      const parsed = parseRouteParamToEnum(item, enumType);

      if (parsed != null) {
        result.push(parsed);
      }
    }
  }

  return result;
}
